export default [
    'General Office',
    'Medical Office',
]